module.exports = __webpack_public_path__ + "static/media/icon-console.03e9b124.png";